import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Link } from 'react-router-dom';
import FestifyLogo from '../../components/FestifyLogo';
import './styles.css';

function Landing() {
  const containerRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
    offset: ['start start', 'end end']
  });

  // Efeitos baseados em scroll para a Hero
  const heroOpacity = useTransform(scrollYProgress, [0, 0.2], [1, 0]);
  const heroScale = useTransform(scrollYProgress, [0, 0.2], [1, 0.9]);
  const heroY = useTransform(scrollYProgress, [0, 0.2], [0, 100]);

  // Efeitos para a galeria (Parallax)
  const leftColY = useTransform(scrollYProgress, [0.1, 0.8], [50, -300]);
  const rightColY = useTransform(scrollYProgress, [0.1, 0.8], [-100, 150]);

  return (
    <div className="landing-wrapper" ref={containerRef}>
      {/* Navbar de vidro */}
      <nav className="landing-nav">
        <div className="nav-content">
          <FestifyLogo size="small" />
          <div className="nav-actions">
            <Link to="/login" className="nav-link">Entrar</Link>
            <Link to="/cadastro" className="cta-btn compact">Começar Agora</Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <motion.section 
        className="hero-section"
        style={{ opacity: heroOpacity, scale: heroScale, y: heroY }}
      >
        <div className="hero-bg-glow"></div>
        <motion.div 
          className="hero-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
        >
          <div className="hero-badge">A nova forma de celebrar</div>
          <h1 className="hero-headline">Eleve seus eventos a outro nível.</h1>
          <p className="hero-subheadline">
            Gerencie convidados, envie convites elegantes e acompanhe cada detalhe da sua festa com uma experiência premium.
          </p>
          <div className="hero-buttons">
            <Link to="/cadastro" className="cta-btn large">Criar meu evento</Link>
            <a href="#recursos" className="ghost-btn large">Explorar recursos</a>
          </div>
        </motion.div>
      </motion.section>

      {/* Scroll Gallery / Features Section */}
      <section id="recursos" className="gallery-section">
        <div className="gallery-header">
          <motion.h2 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8 }}
          >
            Memórias que duram para sempre
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            O Festify garante que a primeira impressão do seu evento seja inesquecível.
          </motion.p>
        </div>

        <div className="gallery-grid">
          {/* Coluna Esquerda */}
          <motion.div className="gallery-col left-col">
            <div className="gallery-item">
              <img src="/images/party_friends.png" alt="Festa e amigos" />
              <div className="item-overlay">
                <h3>Listas Exclusivas</h3>
              </div>
            </div>
            <div className="gallery-item">
              <img src="/images/live_concert.png" alt="Show ao vivo" />
              <div className="item-overlay">
                <h3>Experiências VIP</h3>
              </div>
            </div>
            <div className="gallery-item">
              <img src="/images/elegant_decor.png" alt="Decoração elegante" />
              <div className="item-overlay">
                <h3>Detalhes Únicos</h3>
              </div>
            </div>
          </motion.div>

          {/* Coluna Direita */}
          <motion.div className="gallery-col right-col">
            <div className="gallery-item">
              <img src="/images/music_festival.png" alt="Festival de música" />
              <div className="item-overlay">
                <h3>Momentos Épicos</h3>
              </div>
            </div>
            <div className="gallery-item">
              <img src="/images/birthday_toast.png" alt="Comemoração" />
              <div className="item-overlay">
                <h3>Convites Premium</h3>
              </div>
            </div>
            <div className="gallery-item">
              <img src="/images/checkin.png" alt="Check-in agil" />
              <div className="item-overlay">
                <h3>Check-in Ágil</h3>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Footer / Final CTA */}
      <motion.section 
        className="final-cta"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-50px" }}
        transition={{ duration: 0.8 }}
      >
        <h2>Pronto para celebrar?</h2>
        <p>Crie sua conta em 1 minuto e comece a convidar.</p>
        <Link to="/cadastro" className="cta-btn large">Criar minha conta gratuita</Link>
      </motion.section>

      {/* Rodapé Minimalista */}
      <footer className="landing-footer">
        <div className="footer-content">
          <span className="footer-logo-text">Festify</span>
          <span className="footer-domain">festifyconvitedigital.media</span>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
